import { FeapiError } from '@edreamsodigeo/frontend-api-client';

const DEFAULT_BREAKING_ERROR_CODES = [400, 404, 500];

export const hasFeapiErrors = (errors: FeapiError[] | null) => {
  return Array.isArray(errors) && errors.length > 0;
};

export const hasBreakingFlowErrorCode = (
  httpStatusCode = 0,
  breakingErrors = DEFAULT_BREAKING_ERROR_CODES
) => {
  return breakingErrors.includes(httpStatusCode);
};
